<template>
  <!-- 首页 第五块 -->
  <div class="mcont5">
    <div class="mcont5-title">
      <ul>
        <!-- <li style="margin-bottom:16px;">
          <img src="../../assets/images/logo.png" style="width:200px;"/>
        </li> -->
        <!-- <span>ACTechnology</span> -->
        <li>
          <p>{{ title }}
            <img src="../../assets/images/logo.png" style="width:300px;margin-left: 16px;" />
          </p>
          <span>{{ companyName }}（Acronym Technology）</span>
        </li>
      </ul>
    </div>
    <img src="../../assets/images/new/bg2.png" />
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    title () {
      return this.$store.getters.currentLang === 'zh' ? '株式会社' : '株式会社'
    },
    companyName () {
      return this.$store.getters.currentLang === 'zh' ? '字母科技' : ' アクロニムテクノロジ―'
    }
  }
}
</script>

<style scoped lang="scss">
// 内容模块五
.mcont5 {
  width: 100%;
  background-color: #17181a;
  position: relative;

  &-title {
    height: inherit;
    margin: 0 auto;
    position: absolute;

    > .mc5-ltop {
      width: 180px;
      height: 70px;
      background-color: #525252;
      background-size: 270px;
      background-position: 0px -60px;
      position: relative;
      top: 90px;

      &::after {
        content: "";
        display: block;
        width: 36px;
        height: 2px;
        background: #a38d71;
        position: absolute;
        top: 110px;
      }
    }

    > ul {
      // margin-top: 240px;
      margin-left: 60px;
      width: 100%;

      > li {
        width: inherit;
        // height: 120px;
        margin-bottom: 50px;
        overflow: hidden;

        > img {
          float: left;
          width: 120px;
          margin-right: 30px;
        }

        > p {
          margin-top: 40px;
          color: #000;
          font-size: 3rem;
          font-weight: bold;
          display: flex;
          align-items: center;
        }

        > span {
          color: #8f8f8f;
          font-size: 1.6rem;
        }
      }
    }
  }

  > img {
    width: 100%;
  }
}
</style>


